module.exports = __webpack_public_path__ + "img/bookmark_white_circle.24f40861.png";